// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"7579dca0bed330aba008","293":"031724fe4a7a1e52ce09"}[chunkId] + ".js";
};